import { render, staticRenderFns } from "./UserTreatmentItem.vue?vue&type=template&id=10deae4d&scoped=true&"
import script from "./UserTreatmentItem.vue?vue&type=script&lang=ts&"
export * from "./UserTreatmentItem.vue?vue&type=script&lang=ts&"
import style0 from "./UserTreatmentItem.vue?vue&type=style&index=0&id=10deae4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10deae4d",
  null
  
)

export default component.exports